import React, {useEffect,useState} from "react";
import {$} from "../../../../../vendor";
import VisualInspectionItemsList from "./VisualInspectionItemsList";
import {useSelector, visualInspectionsActions} from "inbooma-api";
import {in_array} from "../../../../utils/Helper";

const VisualInspectionsList = (props) => {
    const { visualInspections, locations,contingents,dispatch, filter, setFilter, sort, setSort, _key, setKey, params, rbac, language, Biscuit, showNotification,t , moment } = props;
    const [openSubmenus, setOpenSubmenus] = useState([]);
    const [markCheckedPending, setMarkCheckedPending] = useState(null);
    const _markAsEnded = useSelector(state => state['visual_inspections_data'].markAsEnded);
    const _deleteVisualInspection = useSelector(state => state["visual_inspections_data"].deleteVisualInspection);
    const [deleteVisualInspectionPending, setDeleteVisualInspectionPending] = useState(null);
    const [marked, setMarked] = useState([]);
    const [localVisualInspections, setLocalVisualInspections] = useState(visualInspections);
    const now = moment().format('DD.MM.YYYY HH:MM');

    useEffect(() => {
        if(_markAsEnded.success === '' || markCheckedPending === null){
            return;
        }
        if(_markAsEnded.success === true){
            let clone = [...marked];
            clone.push(_markAsEnded.id);
            setMarked(clone);
            let clone2 = [...visualInspections];
            clone2[markCheckedPending] = _markAsEnded.data;
            setLocalVisualInspections(clone2);
            showNotification('success',moment(_markAsEnded.data.date).format('DD.MM.YYYY'),t("closed visual inspection."));
        } else {
            showNotification('warning',null,t(_markAsEnded.data?.message));
        }
        setMarkCheckedPending(null);
    },[_markAsEnded]);

    useEffect(() => {
        if(deleteVisualInspectionPending === null || _deleteVisualInspection.success === ''){
            return;
        }
        if(_deleteVisualInspection.success !== true){
            showNotification('warning',null,_deleteVisualInspection.data.message);
        } else {
            let clone = [...visualInspections];
            clone.splice(deleteVisualInspectionPending,1);
            setLocalVisualInspections(clone);
        }
        setDeleteVisualInspectionPending(null);
    }, [_deleteVisualInspection]);

    useEffect(() =>{
        if(_key !== null){
            let selector = '[key='+_key+']';
            if ($(selector).length >= 1) {
                $('html,body').scrollTop($(selector).offset().top - 10)
            }
        }
        if (openSubmenus.length == 0 && visualInspections.length > 0) {
            setOpenSubmenus(
                [...Array(visualInspections.length)].map((_,i) =>
                    new Object({isOpen: false})
                )
            );
        }
    },[]) ;

    const deleteVisualInspection = (visualInspection,key) => {
        if (confirm(t('really_remove'))) {
            dispatch(visualInspectionsActions.deleteVisualInspection(
                {
                    token: Biscuit.get('token'),
                    id: visualInspection.id,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setDeleteVisualInspectionPending(key);
        }
    }
    const openSubmenuHandle = (e,index) => {

        let clone = [...openSubmenus];
        clone[index].isOpen = !clone[index].isOpen;
        setOpenSubmenus(clone);
    };

    const isSubmenuOpen = (index) => {

        if (typeof openSubmenus === 'undefined' || openSubmenus == null || openSubmenus.length <= index)
            return false;

        return openSubmenus[index].isOpen;
    };

    const onMarkChecked = (e,item,index) => {
        dispatch(visualInspectionsActions.markAsEnded(
            {
                token: Biscuit.get('token'),
                id: item.id
            }
        ));
        setMarkCheckedPending(index);
    }


    return (
        <>
            <div className='inb-c-listing off-canvas-content' id="inb-c-main-orders" style={{ minHeight: "1150px" }}>
                {localVisualInspections.map((visualInspection,index) => {
                    let markable = false;
                    let endReached = false;
                    if(visualInspection.visual_inspection_items.length > 0){
                        visualInspection.visual_inspection_items.map(vi => {
                             if(now >= moment(vi.begin).format('DD.MM.YYYY HH:MM') && now < moment(vi.end).format('DD.MM.YYYY HH:MM')){
                                markable = true;
                            }
                            if(now >= moment(vi.end).format('DD.MM.YYYY HH:MM')){
                                endReached = !markable;
                            }
                        });
                    }
                    return (
                        <>
                        <div className={"inb-c-item inb-c-item--order row" + (endReached?" has-form-data":"")} style={isSubmenuOpen(index) ? {paddingBottom:'0px'} : {padding:'0px'}} key={visualInspection.id}>
                            <aside className="inb-c-item__actions">
                                <button className="button round" type="button" style={{opacity: 0,cursor:'inherit'}}> ... </button>
                                <button className={"button round inb-toggle-details inb-toggle-details-"+Biscuit.get('user.client_id')} type="button" title="Wechseln zu Sichtprüfungsitems" onClick={(e) => openSubmenuHandle(e,index)}>
                                    <i className="fi fi-list-thumbnails"></i>
                                    <div className="badge primary reservations-count">{visualInspection.visual_inspection_items === undefined ? 0 : visualInspection.visual_inspection_items.length}</div>
                                </button>
                            </aside>
                            <div className="inb-c-item row" style={{width: '100%',marginRight: '0px',padding: '0px',border: '0'}}>
                                <div className="medium-3 small-2 column inb-order-big" title={t('id')}>{visualInspection.id}</div>
                                <div className="medium-3 small-2 medium-offset-0 column inb-order-big" title={t('date',null,'capital')}>{moment(visualInspection.date).format('DD.MM.YY')}</div>
                                <div className="medium-2 small-6 medium-offset-0 column item-button-group">
                                { rbac.hasPermission('editVisualInspection') && <>
                                    {!in_array(visualInspection.id,marked) && markable &&
                                    <>
                                        {!markCheckedPending ? <div className="button-container left">
                                            <a
                                                href="#"
                                                title={t('closing')}
                                                onClick={e=>onMarkChecked(e,visualInspection,index)}
                                                data-inb-action-link="check">
                                                <button type="button" className="inb-round-btn hollow round float-left">
                                                    <div className="inb-fi-check"></div>
                                                </button>
                                            </a>
                                        </div>:<span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} /></span>}
                                    </>
                                }
                                    <div className="button-container left">
                                        <a
                                            href={"/visual_inspections/"+visualInspection.id}
                                            title=""
                                            data-inb-action-link="edit">
                                            <button type="button" className="inb-round-btn hollow round float-left">
                                                <div className="inb-fi-edit"></div>
                                            </button>
                                        </a>
                                    </div>
                                </>}
                                { rbac.hasPermission('deleteVisualInspection') &&
                                    <>
                                        {!deleteVisualInspectionPending ?
                                    <div className="button-container">
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={ t('delete') }>
                                            <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => deleteVisualInspection(visualInspection,index)}>
                                                <div className="inb-fi-remove"></div>
                                            </button>
                                        </a>
                                    </div>:<span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span> }
                                    </>
                                }
                                </div>
                                {isSubmenuOpen(index) ?
                                    <VisualInspectionItemsList
                                        visualInspection={visualInspection}
                                        dispatch={dispatch}
                                        locations={locations}
                                        contingents={contingents}
                                        showNotification={showNotification}
                                        language={language}
                                        moment={moment}
                                        Biscuit={Biscuit}
                                        t={t}
                                        rbac={rbac}
                                    />: <div className={"inb-contingent-progress"}
                                             style={{marginBottom: "-1rem"}}>
                                        <>
                                            <div className="progress beautify" role="progressbar" tabIndex="0"
                                                 aria-valuenow="50" aria-valuemin="0" aria-valuetext="50 percent" aria-valuemax="100">
                                                <div className="progress-bars">
                                                    {/*<span className="progress-meter" style={{width: "100%"}}> </span>*/}
                                                </div>
                                                <p className="progress-meter-text">
                                                    {visualInspection.visual_inspection_items.length  + " " +t('visual_inspection_items')}
                                                </p>
                                            </div>
                                        </>
                                    </div>
                                }
                        </div>
                        </div>
                        </>);
                })}
            </div>
    </>
    );
}
export default VisualInspectionsList;